import { createAction, props } from '@ngrx/store';
import { IBusinessesResponse } from '../models/businesses.model';

export const loadSelectedBusiness = createAction('[SelectedBusiness] Load SelectedBusiness', props<{ select: IBusinessesResponse }>());

export const loadSelectedBusinesssSuccess = createAction('[SelectedBusiness] Load SelectedBusinesss Success', props<{ data: any }>());

export const loadSelectedBusinesssFailure = createAction('[SelectedBusiness] Load SelectedBusinesss Failure', props<{ error: any }>());
